module.exports = __webpack_public_path__ + "static/img/资讯海报@3x.075a01c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/资讯海报@3x.png
// module id = l4Zr
// module chunks = 192